var SwiperVerger = {
  swiperSlider: "",
  currentIndex: 0,
  init: function () {
    images = $(".slider-mobile .pictures img");

    SwiperVerger.swiperSlider = new Swiper("#presentation .slider-mobile", {
      on: {
        slideChange: function () {
          SwiperVerger.updateImages();
        },
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      spaceBetween: 30,
      loop: true,
    });
    images[0].classList.add("active");
  },
  updateImages: function () {
    if (SwiperVerger.currentIndex != SwiperVerger.swiperSlider.realIndex) {
      if (images[SwiperVerger.swiperSlider.realIndex]) {
        gsap.timeline({
          onComplete: function() {
          }
        })
        .to(images[SwiperVerger.swiperSlider.realIndex], {
          x: 20
        })
        .add( function(){
          images.removeClass("active");
          images[SwiperVerger.swiperSlider.realIndex].classList.add("active");
        })
        .to(images[SwiperVerger.swiperSlider.realIndex], {
          x: 0
        });
      }

    }
    SwiperVerger.currentIndex = SwiperVerger.swiperSlider.realIndex;
  }
};

$(window).load(function(){
    console.log("TOUT VA BIEN");
    if ($("#presentation .slider-mobile").length) {
      SwiperVerger.init();
    }
})
